import { render, staticRenderFns } from "./SearchBarMain.vue?vue&type=template&id=2f8d2a64"
import script from "./SearchBarMain.vue?vue&type=script&lang=js"
export * from "./SearchBarMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports